import {
  resetGetCallLogsProspectProfileSectionRequest,
  setShowDialer,
} from '../../../../dialer-slice';
import { RootState } from '../../../../../../store/root-reducer';
import { createTaskRequest } from '../../../../../tasks/extra-actions';
import { resetCreateTaskRequest } from '../../../../../tasks/tasks-slice';

export const mapStateToProps = (state: RootState) => ({
  showDialer: state?.dialer?.showDialer,
  userTimezone: state?.home?.timeZone,
  getCallLogsProspectProfileSectionResponse:
    state?.dialer?.getCallLogsProspectProfileSectionResponse,
  getCallLogsProspectProfileSectionRequestStatus:
    state?.dialer?.getCallLogsProspectProfileSectionRequest.status,
  createTaskRequestStatus: state.tasks.createTaskRequest.status,
  remainingProspectLimit:
    state.home.getPostLoadMetaResponse?.accountUsageQuotaRemaining?.[
      'PROSPECT.ADD'
    ],
  isDemoAccount: state?.home?.isDemoAccount,
});

export const mapDispatchToProps = {
  onMakeCallClick: (show: boolean) => setShowDialer(show),
  resetGetCallLogsProspectProfileSectionRequest: () =>
    resetGetCallLogsProspectProfileSectionRequest(),
  sendCreateTaskRequest: (payload: unknown) => createTaskRequest(payload),
  resetCreateTaskRequest: () => resetCreateTaskRequest(),
};
